import { render } from "./Pengajuan.vue?vue&type=template&id=07c066a7"
import script from "./Pengajuan.vue?vue&type=script&lang=js"
export * from "./Pengajuan.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__